<template>
  <div v-click-outside="closeSearchTab" class="search-field" @click="onFocus = true">
    <input v-model="inputValue" :placeholder="placeholder" @keyup="searchFunctionChildren" />
    <div v-if="onFocus && datas.length !== 0 && !sameAsInput" class="search-proposal" @click="onFocus = true">
      <div
        v-for="(data, index) in datas"
        :key="index"
        :class="{ 'border-0': index === datas.length - 1 }"
        class="item"
        @click="setIdValue(data)"
      >
        {{ data.text }}
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { APIRequest, FunctionHelpers } from '@/node-sdk'

export default {
  name: 'search-field',
  props: {
    value: String,
    baseUrl: String,
    ressource: String,
    fields: String,
    textValues: Array,
    placeholder: String,
  },

  data() {
    return {
      onFocus: false,
      inputValue: '',
      idValue: this.value,
      datas: [],
      sameAsInput: false,
      loaded: false,
    }
  },

  watch: {
    value: async function () {
      if (this.loaded) {
        await this.setupDefaultValue()
      }
    },
  },

  async mounted() {
    if (this.fields !== undefined) {
      this.datas = await this.searchFunction()
    }
    await this.setupDefaultValue()
    this.loaded = true
  },

  methods: {
    async setupDefaultValue() {
      this.idValue = this.value
      if (this.inputValue === '' && this.idValue) {
        let actualValue = await APIRequest.get_by_id(this.baseUrl, this.ressource, this.idValue)
        if (actualValue !== undefined) {
          for (let i = 0; i < this.textValues.length; i++) {
            this.inputValue += actualValue[this.textValues[i]]
            if (i !== this.textValues.length - 1) {
              this.inputValue += ' '
            }
          }
        }
      } else if (!this.idValue && !this.inputValue) {
        this.inputValue = ''
      }
    },

    async refreshDatas() {
      this.datas = []
      this.datas = await this.searchFunction()
    },

    async searchFunction() {
      return await FunctionHelpers.search(this.baseUrl, this.ressource, this.inputValue, this.fields, this.textValues)
    },

    async searchFunctionChildren() {
      if (this.inputValue === '') {
        this.idValue = null
        this.datas = await this.searchFunction()
        this.$emit('input', this.idValue)
      } else {
        this.datas = await this.searchFunction()
        this.idValue = ''
        this.$emit('input', this.idValue)
        let input_value_to_lower_case = this.inputValue.toLowerCase()
        for (let i = 0; i < this.datas.length; i++) {
          let data_text_to_lower_case = this.datas[i].text.toLocaleLowerCase()
          if (input_value_to_lower_case === data_text_to_lower_case) {
            this.sameAsInput = true
            this.idValue = this.datas[i].id
            this.$emit('input', this.idValue)
          } else {
            this.sameAsInput = false
          }
        }
      }
    },

    setIdValue(data) {
      this.inputValue = data.text
      this.idValue = data.id
      this.$emit('input', this.idValue)
      this.sameAsInput = true
    },

    closeSearchTab() {
      this.onFocus = false
    },
  },

  directives: {
    ClickOutside,
  },
}
</script>

<style scoped></style>
